import React from 'react'
import ReactDom from 'react-dom'
import moment from 'moment'
import TinyScrollbar from './TinyScrollbar'
import { trackEvent } from '../utilities/analytics'

class UnitList extends React.Component {

  constructor(props) {
    super(props)

    this.handleScroll = this.handleScroll.bind(this)
    this.handleUnitClick = this.handleUnitClick.bind(this)
    this.handleUnitEnter = this.handleUnitEnter.bind(this)
    this.handleUnitLeave = this.handleUnitLeave.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.displayCount !== this.props.displayCount
    || nextProps.height !== this.props.height
    || nextProps.mobile !== this.props.mobile
    || nextProps.properties !== this.props.properties
    || nextProps.units !== this.props.units
  }

  handleScroll(event) {
    window.scrollTo(0, document.body.scrollHeight);
  }

  handleUnitClick(event) {
    if (this.props.onUnitClick) {
      event.preventDefault()
      const {units} = this.props
      let id = event.currentTarget.getAttribute('data-unit-id')
      let unitsJS = units.toJS()
      let unit = unitsJS[id]

      trackEvent({
        category: 'Unit List',
        action: 'Click',
        label: `Unit ${unit.id} / Unit Number ${unit.unitnumber}`
      })
      this.props.onUnitClick({
        unit: unit
      })
    }
  }

  handleUnitEnter(event) {
    if (this.props.onUnitOver) {
      event.preventDefault()
      const {units} = this.props
      let id = event.currentTarget.getAttribute('data-unit-id')
      let unitsJS = units.toJS()
      let unit = unitsJS[id]
      this.props.onUnitOver({
        unit: unit,
        x: null,
        y: null
      })
    }
  }

  handleUnitLeave(event) {
    if (this.props.onUnitOver) {
      this.props.onUnitOver({
        unit: null,
        x: null,
        y: null
      })
    }
  }

  render() {
    const {
      displayCount,
      height,
      mobile,
      properties,
      units
    } = this.props

    let unitsJS = units.toJS()

    // The Height of everything in the list other than List Item Container
    let otherHeight = 61 // Matches plus bar below it
    if (properties) {
      otherHeight += 87 // height of the list filters container
    }
    let heightOfContainer = height - otherHeight

    if (mobile) {
      // Height of n list items to show on mobile
      const listItemHeight = 63
      const amountToShowOnMobile = 4
      heightOfContainer = listItemHeight * amountToShowOnMobile
    }

    return (
      <div id="list">
        {properties ? (
          <div className="list-filters-container">
            <div className="filter">
              <select
                onChange={event => window.location = event.target.value}>
                {properties.map((property, index) => (
                  <option
                    key={index}
                    selected={window.location.href === property.value ? 'selected' : null}
                    value={property.value}>
                    {property.label}
                  </option>
                 ))}
              </select>
            </div>
          </div>
        ) : null }

        <p className="list-results">
          <span id="list-number">{ displayCount ? Object.keys(unitsJS).length : null}</span>
          <span id="list-unit"> Matches</span>
          <span id="scroll-indicator"></span>
          <input id="scroll-button" type="button" onClick={this.handleScroll}/>
        </p>

        <hr/>

        <div className="list-item-container" style={{height: heightOfContainer}}>
          <TinyScrollbar height={heightOfContainer}>
          {Object.keys(unitsJS).map((key, index) => {
            return <div key={'unit-list-' + unitsJS[key].id} className="list-item">
                      <a
                        href="#"
                        onClick={this.handleUnitClick}
                        onMouseEnter={this.handleUnitEnter}
                        onMouseLeave={this.handleUnitLeave}
                        data-unit-id={unitsJS[key].id}>
                        <p>
                          <span className="apt-num">Apt {unitsJS[key].unitnumber}</span> <span className="plan-type">{unitsJS[key].floorplan_name}</span><br/>
                          <span className="bedroom-count">{unitsJS[key].floorplan_bedroomcount === '0' ? 'Studio' : unitsJS[key].floorplan_bedroomcount + ' bed'}</span> / <span className="bathroom-count">{parseFloat(unitsJS[key].floorplan_bathroomcount).toString()} bath</span> / <span className="sqft">{unitsJS[key].area} sqft</span><br/>
                          <span className="price">${parseInt(unitsJS[key].price)} Available {unitsJS[key].available === '2' ? 'Now' : moment(unitsJS[key].available_date, 'YYYY-MM-DD').format('MMM Do') }</span>
                        </p>
                      </a>
                    </div>
          })}
          </TinyScrollbar>
        </div>
      </div>
    )
  }
}

UnitList.defaultProps = {
  displayCount: true,
  units: []
}

export default UnitList
